'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixSelectableChild = require('../utils//mix-selectable-child.js');

exports.default = {
  mixins: [(0, _mixSelectableChild.mixSelectableChild)('dof-tag-group')],
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'active',
    event: 'change'
  },
  computed: {
    isActive: function isActive() {
      return this.active || this.isSelected;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('change', !this.active);
      this.triggerSelect();
    }
  }
}; //
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-tag/index.vue
// module id = 414
// module chunks = 0 1